import { AxiosRequestConfig } from 'axios'
import createAPIClient from '../services/apiClient'
import { ConfluencePage } from '../types'

const api = createAPIClient('v2')

export async function getConfluencePage(
  id: string,
  config: AxiosRequestConfig
): Promise<ConfluencePage> {
  const response = await api.get(`/confluence/pages/${id}`, config)

  return response.data
}
